import { createFileRoute, redirect } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/founding-members")({
  head: () => seoHead("/founding-members"),
  beforeLoad: () => {
    throw redirect({ to: "/focus-group", replace: true });
  },
});